import {Directive, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewContainerRef} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig, FieldType} from '../field.interface';
import {InputComponent} from '../input/input.component';
import {ButtonComponent} from '../button/button.component';
import {SelectComponent} from '../select/select.component';
import {DateComponent} from '../date/date.component';
import {RadiobuttonComponent} from '../radiobutton/radiobutton.component';
import {CheckboxComponent} from '../checkbox/checkbox.component';
import {Subject} from 'rxjs';
import {AttachmentComponent} from '../attachment/attachment.component';
import {TextareaComponent} from '../textarea/textarea.component';
import {takeUntil} from 'rxjs/operators';
import {TimeComponent} from '../time/time.component';
import {PaginatedSelectComponent} from '../paginated-select/paginated-select.component';
import {GroupSelectComponent} from '../group-select/group-select.component';
import {PhoneInputComponent} from "../phone-input/phone-input.component";
import {TimerPickerComponent} from "../app-time-picker/time-picker.component";
import {TextEditorComponent} from "../text-editor/text-editor.component";
import {InputChipComponent} from "../input-chip/input-chip.component";
import {ChipComponent} from "../chip/chip.component";
import {InputMapComponent} from "../input-map/input-map.component";

const componentMapper = {
  input: InputComponent,
  inputChip: InputChipComponent,
  inputMap:InputMapComponent,
  chip: ChipComponent,
  // number:NumberInputComponent,
  button: ButtonComponent,
  select: SelectComponent,
  paginatedselect: PaginatedSelectComponent,
  phoneInput: PhoneInputComponent,
  groupselect: GroupSelectComponent,
  attachment: AttachmentComponent,
  date: DateComponent,
  time: TimeComponent,
  time24: TimerPickerComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  textarea: TextareaComponent,
  texteditor: TextEditorComponent,
};

@Directive({
  selector: '[appDynamicField]',
})
export class DynamicFieldDirective implements OnChanges, OnDestroy {
  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  @Input() loading = false;
  @Input() confirmFirst = false;
  @Input() confirmMessage = '';
  @Input() showCancel = true;
  @Input() hideSave = false;
  @Input() cancelText = 'Cancel';
  @Input() saveText = 'Submit';
  @Input() loadingMessage = 'Please Wait, Loading ...';
  @Input() optionData: any;
  // @Input() visible = true;
  @Output() fieldValue = new EventEmitter();
  @Output() cancelForm = new EventEmitter();
  componentRef: any;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private container: ViewContainerRef
  ) {
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.componentRef?.destroy();
  }

  ngOnChanges() {
    if (this.field.type === FieldType.button) {
      this.field = {...this.field, key: 'button'}
    }
    if (this.field.type) {
      if (this.field.type == 'number') {
        console.log(" Number found");
      }
      this.clear();
      if (this.field.key) {
        this.componentRef = this.container.createComponent(componentMapper[this.field.type]);
        if (this.field.type == 'number') {
          console.log(" Number found", this.componentRef);
        }
        this.field.optionData = this.optionData;
        if (this.componentRef.instance) {
          this.componentRef.instance.field = this.field;
          this.componentRef.instance.group = this.group;
          if (this.field.type === FieldType.button) {
            this.componentRef.instance.loadingMessage = this.loadingMessage;
            this.componentRef.instance.confirmFirst = this.confirmFirst;
            this.componentRef.instance.loading = this.loading;
            this.componentRef.instance.hideSave = this.hideSave;
            this.componentRef.instance.saveText = this.saveText;
            this.componentRef.instance.confirmMessage = this.confirmMessage;
          }
          if (this.componentRef.instance.fieldValue) {
            this.componentRef.instance.fieldValue.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
              this.fieldValue.emit(data);
            });
          }
        }
      }
      if (this.field.type === FieldType.button) {
        this.componentRef.instance.cancelForm.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.cancelForm.emit();
        });
      }
    }
  }

  clear() {
    this.container.clear();
  }

}
